import { Badge, Box, Text, Tooltip } from '@wix/design-system';
import React, { useEffect } from 'react';
import { useTranslation } from '../../../hooks/use-translation';
import { useExperiments } from '@wix/wix-experiments-react';
import { getDiscountAmount, getEndDate, getIsDevSale, getIsDiscountTypeIsPercentage, getSaleType, } from '../../../selectors/managedApp';
import { mapSaleTypeToTooltipTitleKey } from '../../../consts';
import css from './discount-label.scss';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { appMarketManageAppsHoverOnSaleBadgeSrc24Evid189, appMarketSaleBannerImpressionWebMobile, } from '@wix/bi-logger-app-market-data/v2';
export const DiscountLabel = ({ app, msid, languageCode = 'en' }) => {
    const t = useTranslation();
    const biLogger = useBiLogger();
    const { experiments } = useExperiments();
    const isDevSale = getIsDevSale(app);
    const isPercentageDiscount = getIsDiscountTypeIsPercentage(app);
    const wixSaleExperiment = experiments.enabled('specs.app-market.Sale');
    const devSaleExperiment = experiments.enabled('specs.app-market.DeveloperSaleBadge');
    const shouldShowWixSale = wixSaleExperiment && !isDevSale && isPercentageDiscount;
    const shouldShowDevSale = devSaleExperiment && isDevSale;
    const percentageValue = getDiscountAmount(app);
    const saleType = getSaleType(app);
    const tooltipTitleKey = mapSaleTypeToTooltipTitleKey[saleType];
    useEffect(() => {
        if (shouldShowWixSale || shouldShowDevSale) {
            biLogger.report(appMarketSaleBannerImpressionWebMobile({
                msid,
                market: origin,
                tag_type: 'manage-apps',
                sale_name: saleType,
            }));
        }
    }, [shouldShowWixSale, shouldShowDevSale, saleType, msid, origin]);
    return (shouldShowWixSale || shouldShowDevSale) ? (React.createElement(Tooltip, { inline: true, content: React.createElement(Box, { direction: 'vertical' }, shouldShowDevSale ? (React.createElement(Text, { light: true, size: 'small' },
            " ",
            t('manage-apps.app-card.discount-label.tooltip.developer-sale', {
                amount: percentageValue,
                endDate: getEndDate(app, languageCode),
            }),
            " ")) :
            React.createElement(React.Fragment, null,
                React.createElement(Text, { weight: 'bold', light: true, size: 'small' }, t(tooltipTitleKey)),
                React.createElement(Text, { light: true, size: 'small' }, t('manage-apps.app-card.discount-label.tooltip.description', {
                    discount: percentageValue,
                })))), onShow: () => {
            biLogger.report(appMarketManageAppsHoverOnSaleBadgeSrc24Evid189({
                app_id: app.appId,
                sale_discount: isPercentageDiscount && Number(percentageValue),
                msid,
            }));
        } },
        React.createElement(Box, { marginRight: "12px" },
            React.createElement(Badge, { type: 'transparent', uppercase: 'false', skin: 'general', size: 'tiny' },
                React.createElement(Text, { className: `${css.discountLabel} ${shouldShowWixSale ? css.appMarketText : ''}`, ellipsis: true }, t('manage-apps.app-card.discount-label', {
                    discount: percentageValue,
                })))))) : null;
};
//# sourceMappingURL=discount-label.js.map